export function isInAppBrowser() {
  const isBrowserIos = sessionStorage.getItem('is_in_app_browser');
  const isBrowserAndroid = document.referrer.includes(
    'android-app://capacitor',
  );

  return isBrowserIos || isBrowserAndroid || false;
}
